import { Language } from './language';

const pt = {
    code: Language.pt,

	// HOME PAGE

	t_description: 'Menina baterista, {age} anos',
	t_close: 'Fechar',
	
	b_home: 'Início',
	b_about: 'Sobre mim',
	b_press: 'Imprensa',
	b_shows: 'Apresentações ao vivo',
	b_soultone: 'Soultone',
	b_collision: 'Collision',
	b_language: 'Português',
	b_share: 'Compartilhar',
	b_scroll_to_top: 'Vá para começar',
	b_click: 'Clique',
	b_tap: 'Pressiona',

	t_english: 'Inglês',
	t_spanish: 'Espanhol',
	t_portuguese: 'Português',
	t_italian: 'Italiano',
	t_french :'Francês',
	t_german: 'Alemão',
	t_chinese: 'Chinês',

	// SHOWS PAGE

	ClassicMetal_title: 'Metal Clássico',
	ClassicMetal_description: 'School of Rock Seattle',

	StAlsGrandDay2024_title: 'Apresentação do Dia dos Avós 2024',
	StAlsGrandDay2024_description: 'Escola Santo Afonso em Seattle',

	BlackViolinConcert_title: 'Concerto de Violino Negro com The World Your Orchestra',
	BlackViolinConcert_description: 'O Teatro Paramount',

	MexicanIndependenceDay2024_title: 'Celebração da Independência do México com a Orquestra Cívica Ballard',
	MexicanIndependenceDay2024_description: 'Prefeitura de Seattle',

	BluesRock_title: 'Blues Rock',
	BluesRock_description: 'School of Rock Seattle',

	BallardSeaFoodFest2024_title: 'Festival de Frutos do Mar Ballard 2024',
	BallardSeaFoodFest2024_description: 'Festival de Frutos do Mar Ballard',

	Funk_title: 'Funk',
	Funk_description: 'School of Rock Seattle',

	Heart_title: 'Heart',
	Heart_description: 'School of Rock Seattle',

	ModernMetal_title: 'Metal Moderno',
	ModernMetal_description: 'School of Rock Seattle',

	SeasonPreviewWinter2023_title: 'Prévia da Temporada Inverno 2023',
	SeasonPreviewWinter2023_description: 'School of Rock Seattle',

	SmashingPumpkins_title: 'Smashing Pumpkins',
	SmashingPumpkins_description: 'School of Rock Seattle',

	Nirvana_title: 'Nirvana',
	Nirvana_description: 'School of Rock Seattle',

	HairMetal_title: 'Hair Metal',
	HairMetal_description: 'School of Rock Seattle',

	TalentShow2023_title: 'Show de Talentos 2023',
	TalentShow2023_description: 'Seattle Salmon Bay K-8',

	Deftones_title: 'Deftones',
	Deftones_description: 'School of Rock Seattle',

	SeasonPreviewSpring2023_title: 'Prévia da Temporada Primavera de 2023',
	SeasonPreviewSpring2023_description: 'School of Rock Seattle',

	Ramones_title: 'Os Ramones',
	Ramones_description: 'School of Rock Seattle',

	Soundtrack_title: 'Show da Trilha Sonora',
	Soundtrack_description: 'School of Rock Seattle',

	PopPunkVsEmo_title: 'Pop Punk Vs. Emo',
	PopPunkVsEmo_description: 'School of Rock Seattle',

	_90sNostalgia_title: 'Nostalgia dos anos 90',
	_90sNostalgia_description: 'School of Rock Seattle',

	TalentShow2022_title: 'Show de Talentos 2022',
	TalentShow2022_description: 'Seattle Salmon Bay K-8',

	// PRESS PAGE

	b_watch_here: 'Veja aqui',

	fox_13_news_title: 'Relatório de notícias da Fox 13 Seattle',
	fox_13_news_description: 'Relatório na seção "True Northwest"',

	the_daly_migs_show_interview_title: 'Entrevista com The Daly Migs Show',
	the_daly_migs_show_interview_description: 'Entrevista sobre ser convidado para subir ao palco com Godsmack',

	alizee_defan_07_02_2024_title: 'Entrevista com "Alizee Defan"',
	alizee_defan_07_02_2024_description: 'Entrevista exclusiva',

	jaime_mendez_news_06_26_2024_title: 'Entrevista "Jaime Mendez News"',
	jaime_mendez_news_06_26_2024_description: 'Notícias locais de Seattle em espanhol',

	bien_informado_03_22_2023_title: 'Artigo de "Bien Informado"',
	bien_informado_03_22_2023_description: 'Artigo do site de notícias argentino sobre Victoria',

	wave_potter_reaction_01_30_2023_title: 'A reação de Wave Potter',
	wave_potter_reaction_01_30_2023_description: 'Wave Potter reage ao cover de Victoria Lux Æterna do Metallica',
	
	// ABOUT PAGE

	b_back: 'Volte',

	t_title: 'Victoria Acosta',
	t_pronouns: '(ela)',

	b_read_more: 'Leia mais',
	b_read_less: 'Leia menos',
	
	t_about: `
Com as baquetas nas mãos e o ritmo na alma, Victoria Acosta, {age} anos, encanta o público como uma das jovens bateristas mais promissoras da atualidade.

Nascida em El Paso, Texas, e criada em Guadalajara, México, Victoria vive atualmente em Seattle, onde continua a impressionar com sua dedicação extraordinária à música.

Sua paixão pela bateria começou aos quatro anos de idade. Quando ganhou sua primeira bateria, em 13 de setembro de 2018, tudo mudou. Iniciou seus estudos musicais na academia Musicalerias de Guadalajara e os continuou em Seattle, demonstrando uma rápida evolução. Após uma aula experimental marcante na School of Rock em 29 de maio de 2022, foi aceita diretamente no Performers Program, pulando o curso introdutório. Desde então, Victoria tem encantado o público em {shows} apresentações ao vivo, com sua energia contagiante e presença de palco impressionante.

Mas sua jornada musical vai muito além dos palcos. Victoria gravou centenas de vídeos para as redes sociais, conquistando uma base fiel de fãs. Em 13 de junho de 2024, foi convidada como baterista pelo compositor italiano Alberto Rigonni para o álbum Nemesis Call. No mesmo ano, assinou um contrato de patrocínio com a Soultone Cymbals em 12 de setembro, e em 8 de março de 2025 passou a fazer parte do time de artistas da Collision Drumsticks—mais um marco importante em sua jovem carreira.

Victoria não se limita à bateria: ela também começou a estudar violino na quarta série. Em 2024, ingressou na World Youth Orchestra, se apresentou com o duo Black Violin no Paramount Theatre e estreou como percussionista na Ballard Civic Orchestra no Town Hall de Seattle durante as comemorações do Dia da Independência do México.

Entre suas diversas conquistas estão o Gold Prize e o Fantastic Technique Award no concurso London Young Musician 2022, além do Annual Star Musician Award e do Outstanding Drummer Special Award recebidos em 2023.

Victoria pratica todos os dias, superando seus próprios limites tanto na bateria quanto no violino. Com uma paixão inabalável e criatividade sem limites, ela não é apenas uma promessa—é uma verdadeira força da natureza em ascensão.
	`,

	// PRESS PAGE

	t_footer: 'Todos os direitos reservados',

	// SOULTONE: 

	b_visit_artist_page: 'Visite minha página de artista'

};

export default pt;
